/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const getBackEsisteVotoId = (
  idListaElettorale: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-bo-procedimenti/esiste-voto/${idListaElettorale}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackEsisteVotoIdQueryKey = (idListaElettorale: string) =>
  [`/framework-bo-procedimenti/esiste-voto/${idListaElettorale}`] as const;

export const getGetBackEsisteVotoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackEsisteVotoId>>,
  TError = ErrorType<unknown>,
>(
  idListaElettorale: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackEsisteVotoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackEsisteVotoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackEsisteVotoIdQueryKey(idListaElettorale);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackEsisteVotoId>>
  > = ({ signal }) =>
    getBackEsisteVotoId(idListaElettorale, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idListaElettorale, ...queryOptions };
};

export type GetBackEsisteVotoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackEsisteVotoId>>
>;
export type GetBackEsisteVotoIdQueryError = ErrorType<unknown>;

export const useGetBackEsisteVotoId = <
  TData = Awaited<ReturnType<typeof getBackEsisteVotoId>>,
  TError = ErrorType<unknown>,
>(
  idListaElettorale: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackEsisteVotoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackEsisteVotoIdQueryOptions(
    idListaElettorale,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackEsisteVotoIdId = (
  idGruppoTipoDomanda: string,
  idUtente: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-bo-procedimenti/esiste-voto/${idGruppoTipoDomanda}/${idUtente}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackEsisteVotoIdIdQueryKey = (
  idGruppoTipoDomanda: string,
  idUtente: string,
) =>
  [
    `/framework-bo-procedimenti/esiste-voto/${idGruppoTipoDomanda}/${idUtente}`,
  ] as const;

export const getGetBackEsisteVotoIdIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackEsisteVotoIdId>>,
  TError = ErrorType<unknown>,
>(
  idGruppoTipoDomanda: string,
  idUtente: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackEsisteVotoIdId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackEsisteVotoIdId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackEsisteVotoIdIdQueryKey(idGruppoTipoDomanda, idUtente);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackEsisteVotoIdId>>
  > = ({ signal }) =>
    getBackEsisteVotoIdId(
      idGruppoTipoDomanda,
      idUtente,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idGruppoTipoDomanda && idUtente),
    ...queryOptions,
  };
};

export type GetBackEsisteVotoIdIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackEsisteVotoIdId>>
>;
export type GetBackEsisteVotoIdIdQueryError = ErrorType<unknown>;

export const useGetBackEsisteVotoIdId = <
  TData = Awaited<ReturnType<typeof getBackEsisteVotoIdId>>,
  TError = ErrorType<unknown>,
>(
  idGruppoTipoDomanda: string,
  idUtente: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackEsisteVotoIdId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackEsisteVotoIdIdQueryOptions(
    idGruppoTipoDomanda,
    idUtente,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
